// CustomModal.js
import React, { ReactElement } from 'react';
import Modal from 'react-modal';

interface IProps {
  isOpen: boolean
  onRequestClose: () => void
  children: ReactElement
}
const GameModal = ({ isOpen, onRequestClose, children }: IProps) => {

  const customStyles = {
    overlay: {
      zIndex: 2147483647,
      background: "#0b1222",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: 0
    },
    content: {
      background: "#0b1222",
      border: 0,
      borderRadius: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: 0,
      overflow: "initial",
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Modal"
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
      style={customStyles}


    >
      <div className='gameloader-wrapper'>

        <div className='iframe-wrapper'>
          {children}
        </div>
        <div className='buttons'>
          <i onClick={onRequestClose} className="icon icon-modal-close"></i>
        </div>
      </div>
    </Modal>
  );
};

export default GameModal;
